/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { useLoading } from '../../../providers/LoadingProvider';

const PIXPage = () => {
  const [url, setUrl] = useState('');
  const { show, hide } = useLoading();

  useEffect(() => {
    show();
    const urlData = localStorage.getItem('urlPix');
    setUrl(urlData);
    hide();
    return () => {
      localStorage.removeItem('urlPix');
    };
  }, [show, hide]);

  return (
    <>
      <Container className="dashboard">
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
          <iframe
            src={url}
            title="Embed"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0
            }}
          />
        </div>
      </Container>
    </>
  );
};

export default PIXPage;
